import { render, staticRenderFns } from "./DonutChart61.vue?vue&type=template&id=6610ed7c&scoped=true"
import script from "./DonutChart61.vue?vue&type=script&lang=js"
export * from "./DonutChart61.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6610ed7c",
  null
  
)

export default component.exports